import {useAuthenticatedMedia} from '../../../hooks/useAuthenticatedMedia';
import {CallAvatar, type CallAvatarSize} from './CallAvatar';

interface MemberAvatarProps {
    readonly userId: string;
    readonly name: string;
    readonly mxcAvatarUrl?: string | null;
    readonly size: CallAvatarSize;
    readonly className?: string;
}

export const MemberAvatar = ({userId, name, mxcAvatarUrl, size, className}: MemberAvatarProps) => {
    const {blobUrl} = useAuthenticatedMedia(mxcAvatarUrl || '');
    return <CallAvatar identity={{userId, name, avatarUrl: blobUrl || undefined}} size={size} className={className}/>;
};
